import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleXmark} from "@fortawesome/free-solid-svg-icons";
import {useErrorTranslation} from "../../api/utilities/translateErrorMessage.js";
import {useEffect, useState} from "react";

/**
 * Error can be text, or error object...
 */
export default function FormError({error, className}) {

    const {et} = useErrorTranslation();
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        et(error).then(setErrorMessage);
    }, []);

    return (
        <div role="alert"
             className={
                 "w-full mb-6 bg-rose-100 rounded-md dark:bg-rose-400/30 dark:border-transparent border text-rose-600 dark:text-rose-400 border-rose-200"
                 + ' ' + className
             }
        >
            <div className="inline-flex px-4 py-2  text-sm">
                <div className="flex w-full justify-between items-start">
                    <div className="flex gap-2">
                        <div><FontAwesomeIcon icon={faCircleXmark}/></div>
                        <div>{errorMessage}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
